import React from 'react';

export interface FilterColumnSelectOption {
  value: string;
  label: string;
}

function getOptionLabel(optionLabel: React.ReactNode, value: unknown): string {
  if (typeof optionLabel === 'string' || typeof optionLabel === 'number') {
    return String(optionLabel);
  }

  if (optionLabel === undefined || optionLabel === null) {
    return String(value);
  }

  if (React.isValidElement(optionLabel)) {
    return String(value);
  }

  return String(optionLabel);
}

export function parseFilterColumnSelectOptions(
  children: React.ReactNode
): FilterColumnSelectOption[] {
  const options: FilterColumnSelectOption[] = [];

  React.Children.forEach(children, (child) => {
    if (
      !React.isValidElement<{ value?: unknown; children?: React.ReactNode }>(
        child
      )
    ) {
      return;
    }

    const { value, children: optionLabel } = child.props;

    if (value === undefined || value === null) {
      return;
    }

    options.push({
      value: String(value),
      label: getOptionLabel(optionLabel, value),
    });
  });

  return options;
}
